export default {
  // 用户类型
  userType: {
    1: '机构',
    2: '开发商',
  },
  // 角色类型
  roleType: {
    1: '用户角色',
    2: '系统成员角色',
  },
};
